// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: NdFBK2CrJIH5
import * as React from 'react';
import {
  PlasmicImg as PlasmicImg__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant,
} from '@plasmicapp/react-web';
import { useDataEnv } from '@plasmicapp/react-web/lib/host';
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from './PlasmicGlobalVariant__Screen'; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import '@plasmicapp/react-web/lib/plasmic.css';
import plasmic_antd_5_hostless_css from '../antd_5_hostless/plasmic_antd_5_hostless.module.css'; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from './plasmic_collect_wise_draft.module.css'; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from './PlasmicSidebar.module.css'; // plasmic-import: NdFBK2CrJIH5/css
import _1OverviewSvgVn4XXzNxbxq0 from './images/_1OverviewSvg.svg'; // plasmic-import: Vn4xXzNXBXQ0/picture
import _4ContactsSvgJzBj3ADyazoV from './images/_4ContactsSvg.svg'; // plasmic-import: jzBj3aDyazoV/picture
import _2TicketsSvgMJzjYa80McxP from './images/_2TicketsSvg.svg'; // plasmic-import: MJzjYa80McxP/picture
import a1SettingsSvgYtsQRbrVMrbJ from './images/a1SettingsSvg.svg'; // plasmic-import: YtsQRbrVMrbJ/picture
// Add your Call History icon import here - you'll need to create or get this SVG
import callHistoryIcon from './images/phone.svg';
import usageIcon from './images/usage.svg';


createPlasmicElementProxy;

export const PlasmicSidebar__VariantProps = new Array();

export const PlasmicSidebar__ArgProps = new Array();

const $$ = {};

function PlasmicSidebar__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants,
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft(),
  });
  return (
    <Stack__
      as={'div'}
      data-plasmic-name={'root'}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={'dashboardButton'}
        data-plasmic-override={overrides.dashboardButton}
        className={classNames(projectcss.all, sty.dashboardButton)}
      >
        <PlasmicImg__
          alt={''}
          className={classNames(sty.img__zbYx)}
          displayHeight={
            hasVariant(globalVariants, 'screen', 'medium')
              ? '1.04vw'
              : hasVariant(globalVariants, 'screen', 'large')
                ? '1.04vw'
                : '17px'
          }
          displayMaxHeight={'none'}
          displayMaxWidth={'100%'}
          displayMinHeight={'0'}
          displayMinWidth={'0'}
          displayWidth={
            hasVariant(globalVariants, 'screen', 'medium')
              ? '1.04vw'
              : hasVariant(globalVariants, 'screen', 'large')
                ? '1.04vw'
                : '17px'
          }
          loading={'lazy'}
          src={{
            src: _1OverviewSvgVn4XXzNxbxq0,
            fullWidth: 150,
            fullHeight: 150,
            aspectRatio: 1,
          }}
        />

        <div
          data-plasmic-name={'title'}
          data-plasmic-override={overrides.title}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title
          )}
        >
          {'Dashboard'}
        </div>
      </div>
      <button
        data-plasmic-name={'clientsButton'}
        data-plasmic-override={overrides.clientsButton}
        className={classNames(
          projectcss.all,
          projectcss.button,
          sty.clientsButton
        )}
        ref={(ref) => {
          $refs['clientsButton'] = ref;
        }}
      >
        <PlasmicImg__
          alt={''}
          className={classNames(sty.img___8G21)}
          displayHeight={
            hasVariant(globalVariants, 'screen', 'medium')
              ? '1.04vw'
              : hasVariant(globalVariants, 'screen', 'large')
                ? '1.04vw'
                : '17px'
          }
          displayMaxHeight={'none'}
          displayMaxWidth={'100%'}
          displayMinHeight={'0'}
          displayMinWidth={'0'}
          displayWidth={
            hasVariant(globalVariants, 'screen', 'medium')
              ? '1.04vw'
              : hasVariant(globalVariants, 'screen', 'large')
                ? '1.04vw'
                : '17px'
          }
          loading={'lazy'}
          src={{
            src: _4ContactsSvgJzBj3ADyazoV,
            fullWidth: 150,
            fullHeight: 150,
            aspectRatio: 1,
          }}
        />

        <div
          data-plasmic-name={'title4'}
          data-plasmic-override={overrides.title4}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title4
          )}
        >
          {hasVariant(globalVariants, 'screen', 'large')
            ? 'Debtors'
            : 'Debtors'}
        </div>
      </button>
      <div
        data-plasmic-name={'paymentsButton'}
        data-plasmic-override={overrides.paymentsButton}
        className={classNames(projectcss.all, sty.paymentsButton)}
      >
        <PlasmicImg__
          alt={''}
          className={classNames(sty.img___8B76W)}
          displayHeight={
            hasVariant(globalVariants, 'screen', 'medium')
              ? '1.04vw'
              : hasVariant(globalVariants, 'screen', 'large')
                ? '1.04vw'
                : '17px'
          }
          displayMaxHeight={'none'}
          displayMaxWidth={'100%'}
          displayMinHeight={'0'}
          displayMinWidth={'0'}
          displayWidth={
            hasVariant(globalVariants, 'screen', 'medium')
              ? '1.04vw'
              : hasVariant(globalVariants, 'screen', 'large')
                ? '1.04vw'
                : '17px'
          }
          loading={'lazy'}
          src={{
            src: _2TicketsSvgMJzjYa80McxP,
            fullWidth: 150,
            fullHeight: 150,
            aspectRatio: 1,
          }}
        />

        <div
          data-plasmic-name={'title2'}
          data-plasmic-override={overrides.title2}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title2
          )}
        >
          {'Payments'}
        </div>
      </div>
      {/* New Call History Button */}
      <div
        data-plasmic-name={'callHistoryButton'}
        data-plasmic-override={overrides.callHistoryButton}
        className={classNames(projectcss.all, sty.paymentsButton)}
      >
        <PlasmicImg__
          alt={''}
          className={classNames(sty.img___8B76W)}
          displayHeight={
            hasVariant(globalVariants, 'screen', 'medium')
              ? '1.04vw'
              : hasVariant(globalVariants, 'screen', 'large')
                ? '1.04vw'
                : '17px'
          }
          displayMaxHeight={'none'}
          displayMaxWidth={'100%'}
          displayMinHeight={'0'}
          displayMinWidth={'0'}
          displayWidth={
            hasVariant(globalVariants, 'screen', 'medium')
              ? '1.04vw'
              : hasVariant(globalVariants, 'screen', 'large')
                ? '1.04vw'
                : '17px'
          }
          loading={'lazy'}
          src={{
            src: callHistoryIcon,
            fullWidth: 150,
            fullHeight: 150,
            aspectRatio: 1,
          }}
        />

        <div
          data-plasmic-name={'callHistoryTitle'}
          data-plasmic-override={overrides.callHistoryTitle}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title2
          )}
        >
          {'Call History'}
        </div>
      </div>
      <div
        data-plasmic-name={'settingsButton'}
        data-plasmic-override={overrides.settingsButton}
        className={classNames(projectcss.all, sty.settingsButton)}
      >
        <PlasmicImg__
          alt={''}
          className={classNames(sty.img__swuZn)}
          displayHeight={
            hasVariant(globalVariants, 'screen', 'medium') ? '1.04vw' : '17px'
          }
          displayMaxHeight={'none'}
          displayMaxWidth={'100%'}
          displayMinHeight={'0'}
          displayMinWidth={'0'}
          displayWidth={
            hasVariant(globalVariants, 'screen', 'medium') ? '1.04vw' : '17px'
          }
          loading={'lazy'}
          src={{
            src: a1SettingsSvgYtsQRbrVMrbJ,
            fullWidth: 150,
            fullHeight: 150,
            aspectRatio: 1,
          }}
        />

        <div
          data-plasmic-name={'title5'}
          data-plasmic-override={overrides.title5}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title5
          )}
        >
          {'Settings'}
        </div>
      </div>
      <div
        data-plasmic-name={'settingsButton2'}
        data-plasmic-override={overrides.settingsButton2}
        className={classNames(projectcss.all, sty.settingsButton2)}
      >
        <PlasmicImg__
          alt={''}
          className={classNames(sty.img__wyltl)}
          displayHeight={
            hasVariant(globalVariants, 'screen', 'medium')
              ? '1.04vw'
              : hasVariant(globalVariants, 'screen', 'large')
                ? '1.04vw'
                : '17px'
          }
          displayMaxHeight={'none'}
          displayMaxWidth={'100%'}
          displayMinHeight={'0'}
          displayMinWidth={'0'}
          displayWidth={
            hasVariant(globalVariants, 'screen', 'medium')
              ? '1.04vw'
              : hasVariant(globalVariants, 'screen', 'large')
                ? '1.04vw'
                : '17px'
          }
          loading={'lazy'}
          src={{
            src: usageIcon,
            fullWidth: 150,
            fullHeight: 150,
            aspectRatio: 1,
          }}
        />

        <div
          data-plasmic-name={'title6'}
          data-plasmic-override={overrides.title6}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title6
          )}
        >
          {'Usage'}
        </div>
      </div>
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: [
    'root',
    'dashboardButton',
    'title',
    'clientsButton',
    'title4',
    'paymentsButton',
    'title2',
    'callHistoryButton',
    'callHistoryTitle',
    'settingsButton',
    'title5',
    'settingsButton2',
    'title6',
  ],

  dashboardButton: ['dashboardButton', 'title'],
  title: ['title'],
  clientsButton: ['clientsButton', 'title4'],
  title4: ['title4'],
  paymentsButton: ['paymentsButton', 'title2'],
  title2: ['title2'],
  callHistoryButton: ['callHistoryButton', 'callHistoryTitle'],
  callHistoryTitle: ['callHistoryTitle'],
  settingsButton: ['settingsButton', 'title5'],
  title5: ['title5'],
  settingsButton2: ['settingsButton2', 'title6'],
  title6: ['title6'],
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSidebar__ArgProps,
          internalVariantPropNames: PlasmicSidebar__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicSidebar__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === 'root') {
    func.displayName = 'PlasmicSidebar';
  } else {
    func.displayName = `PlasmicSidebar.${nodeName}`;
  }
  return func;
}

export const PlasmicSidebar = Object.assign(
  // Top-level PlasmicSidebar renders the root element
  makeNodeComponent('root'),
  {
    // Helper components rendering sub-elements
    dashboardButton: makeNodeComponent('dashboardButton'),
    title: makeNodeComponent('title'),
    clientsButton: makeNodeComponent('clientsButton'),
    title4: makeNodeComponent('title4'),
    paymentsButton: makeNodeComponent('paymentsButton'),
    title2: makeNodeComponent('title2'),
    callHistoryButton: makeNodeComponent('callHistoryButton'),
    callHistoryTitle: makeNodeComponent('callHistoryTitle'),
    settingsButton: makeNodeComponent('settingsButton'),
    title5: makeNodeComponent('title5'),
    settingsButton2: makeNodeComponent('settingsButton2'),
    title6: makeNodeComponent('title6'),
    // Metadata about props expected for PlasmicSidebar
    internalVariantProps: PlasmicSidebar__VariantProps,
    internalArgProps: PlasmicSidebar__ArgProps,
  }
);

export default PlasmicSidebar;
/* prettier-ignore-end */
